import leftPad from "left-pad";

export function formatDateAsIso(input: Date): string {
    const parts = [
        input.getFullYear(),
        leftPad(input.getMonth() + 1, 2, "0"),
        leftPad(input.getDate(), 2, "0")
    ];

    return parts.join("-");
}

export function formatDateAsUk(input: Date): string {
    const parts = [
        leftPad(input.getDate(), 2, "0"),
        leftPad(input.getMonth() + 1, 2, "0"),
        input.getFullYear()
    ];

    return parts.join("/");
}

export function dateOrNull(input: any): Date | null {
    if (!input) {
        return null;
    }

    const date = new Date(input);
    return isNaN(date.getTime()) ? null : date;
}